import Box from '@mui/material/Box';
import { NextButton, PrevButton } from '../Steppers';
import type { DateRange } from '../types';
import { usePicker } from './PickerProvider';

export function StepNavigation() {
  const { draftValue, emitInteraction, setDraftValue } = usePicker();

  const handlePrevious = (nextValue: DateRange) => {
    setDraftValue(nextValue);
    emitInteraction({ type: 'step.previous', value: nextValue });
  };

  const handleNext = (nextValue: DateRange) => {
    setDraftValue(nextValue);
    emitInteraction({ type: 'step.next', value: nextValue });
  };

  return (
    <Box display="flex" gap={1}>
      <PrevButton value={draftValue} onClick={handlePrevious} />
      <NextButton value={draftValue} onClick={handleNext} />
    </Box>
  );
}
